export var NOTIFIER_NAME = 'airbrake-js/browser';
export var NOTIFIER_VERSION = '2.1.7';
export var NOTIFIER_URL = 'https://github.com/airbrake/airbrake-js/tree/master/packages/browser';
